<template>
  <div style="width: 100%; height: 100%">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, onUnmounted } from "vue";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

//let applyRotation = false;

// Define las propiedades que el componente aceptará
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    default: null,
  },
});

// Referencia al elemento <canvas>
const chartCanvas = ref(null);
let chartInstance = null;
const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  //rotation: applyRotation ? 0 : -100 ,
  layout: {
    padding: {
      left: 10,
      right: 10,
      top: 10,
      bottom: 10,
    },
  },
  plugins: {
    legend: { display: false },
    title: { display: false },
    datalabels: {
      formatter: (value, ctx) => {
        const total = ctx.chart.data.datasets[0].data.reduce(
          (sum, current) => sum + current,
          0
        );
        const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
        return [`${ctx.chart.data.labels[ctx.dataIndex]}`, `${percentage}%`];
      },
      color: "#000",
      font: { weight: 600, size: 14 },
      padding: 6,
      textAlign: "center",
      anchor: "end", // Mantiene el punto de anclaje al final
      align: "end", // Alinea el texto al final del punto de anclaje
      offset: 0, // Elimina el desplazamiento para que no floten
      lineHeight: 1.4,
      textStrokeColor: "white",
      textStrokeWidth: 2,
      drawTime: "afterDatasetsDraw",
      clamp: true,
      clip: false,
      display: (context) => context.dataset.data[context.dataIndex] > 0,
    },
  },
};

const createChart = () => {
  if (chartInstance) {
    chartInstance.destroy();
  }

  Chart.register(ChartDataLabels);

  const value1 = props.data.datasets[0].data[0];
  const value2 = props.data.datasets[0].data[1];
  const total = value1 + value2;

  let responsiveRotation = 0;

  if (total > 0) {
    // Calculate the percentage of the first slice
    const firstSlicePercentage = value1 / total;

    const firstSliceAngle = firstSlicePercentage * 360;
    responsiveRotation = 90 - firstSliceAngle / 2;
  }
  defaultOptions.rotation = responsiveRotation;

  const config = {
    type: "pie",
    data: props.data,
    options: props.options ?? defaultOptions,
  };

  chartInstance = new Chart(chartCanvas.value, config);
};

watch(
  () => props.data,
  () => {
    createChart();
  },
  { deep: true }
);

watch(
  () => props.options,
  () => {
    createChart();
  },
  { deep: true }
);

onMounted(() => {
  createChart();
});

onUnmounted(() => {
  if (chartInstance) {
    chartInstance.destroy();
  }
});
</script>
